import axios from 'axios'
import * as Security from '@/common/security_manager'
import { getCookie, hkTokenOrBearerToken } from '@/common/utils'
import store from '@/store/store'

const coreApiBase = () =>
  `${window.hkConfigEnvs.VUE_APP_ENTERPRISE_URL}/${window.hkConfigEnvs.VUE_APP_CORE_API}`

function buildAuthHeaders() {
  const state = store.state.current
  let token, info

  if (state.sso_login || state.cognito_login || state.google_login) {
    token = localStorage.getItem('hk_token')
    info = state.hk_info
  } else {
    const tokenObj = Security.getTokenObject()
    token = tokenObj.token
    info = tokenObj.info
  }

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...hkTokenOrBearerToken(token),
    'hk-info': info,
    'hk-app-id': 'HK_HOME',
    'hk-app-version': window.hkConfigEnvs.VUE_APP_VERSION,
    'hk-session-id': getCookie('hk_session_id')
  }
}

const LanguageService = {
  /**
   * GET /{enterprise_id}/languages/by-app-id
   * Returns the list of active languages for the enterprise, filtered by the app_id the backend reads from the hk-app-id request header.
   */
  getEnterpriseLanguages(enterpriseId) {
    const url = `${coreApiBase()}/${enterpriseId}/languages/by-app-id`
    return axios.get(url, { headers: buildAuthHeaders() })
  },

  /**
   * PUT /{enterprise_id}/users/{user_id}/language
   * Persists the selected language code for the given user.
   */
  updateUserLanguage(enterpriseId, userId, languageCode) {
    const url = `${coreApiBase()}/${enterpriseId}/users/${userId}/language`
    return axios.put(url, { language_code: languageCode }, { headers: buildAuthHeaders() })
  }
}

export default LanguageService
